import { personsAndTeamsOf } from '../values.js';
import { resolveReceiver, uniqueRecipients } from './receiver.js';
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/** Every address in a free-text cell (monday's email column renders `a@b.c`, possibly labelled). */
export function addressesIn(text) {
    if (text === null)
        return [];
    return text
        .split(/[\s,;]+/)
        .map((part) => part.trim())
        .filter((part) => EMAIL.test(part));
}
export async function resolveEmailRecipients(context, receiver) {
    const addresses = [];
    if (receiver.type === 'column' && context.itemId !== null && receiver.value !== null) {
        const columnId = typeof receiver.value === 'object' ? receiver.value.columnId : String(receiver.value);
        const cell = await context.services.getCellValue(context.itemId, columnId);
        const people = personsAndTeamsOf(cell).filter((entry) => entry.kind === 'person');
        if (people.length === 0) {
            // An `email` or `text` column: the address is the cell's own display text.
            addresses.push(...addressesIn(await context.services.getCellText(context.itemId, columnId)));
            return uniqueRecipients(addresses);
        }
    }
    const userIds = await resolveReceiver(context, receiver);
    const lookup = context.services.userEmail;
    if (lookup === undefined)
        return [];
    for (const userId of userIds) {
        const email = await lookup(userId);
        if (email !== null && EMAIL.test(email))
            addresses.push(email);
    }
    return uniqueRecipients(addresses);
}
//# sourceMappingURL=email-receiver.js.map